import { put, call, takeEvery, all } from 'redux-saga/effects';

import * as actions from '@actions/vatReturn';
import {
  generateVatReturn,
  sendVatReturnEmail,
  getVatReturnBankDetails,
  getVatReturnEntryList,
  getCzechEconomicActivityList,
  getItalyVatReturnList,
} from '@api/vatReturn';
import types from '@constants/action-types';
import { handleRequest } from '@sagas/request';

import { handleDownloadFiledReturnFiles } from './handleDownloadFiledReturnFiles';
import { handleDownloadVatReturnRequest } from './handleDownloadVatReturnRequest';

export const handleGenerateVatReturnRequest = function* ({ payload }) {
  try {
    const response = yield call(generateVatReturn, payload);
    if (response.isAxiosError) return yield put(actions.generateVatReturnFailure(response.message));
    if (response) {
      yield put(actions.generateVatReturnSuccess(response));
    } else {
      yield put(actions.generateVatReturnFailure(response));
    }
  } catch (e) {
    yield put(actions.generateVatReturnFailure(e));
  }
};

export const handleGetVatReturnEntryListRequest = function* ({ payload }) {
  try {
    const response = yield call(getVatReturnEntryList, payload);
    if (response.isAxiosError)
      return yield put(actions.getVatReturnEntryListFailure(response.message));
    yield put(actions.getVatReturnEntryListSuccess(response));
  } catch (e) {
    yield put(actions.getVatReturnEntryListFailure(e));
  }
};

export const handleSendVatReturnEmailRequest = function* ({ payload }) {
  try {
    const response = yield call(sendVatReturnEmail, payload);
    if (response.isAxiosError)
      return yield put(actions.sendVatReturnEmailFailure(response.message));
    yield put(actions.sendVatReturnEmailSuccess(response));
  } catch (e) {
    yield put(actions.sendVatReturnEmailFailure(e));
  }
};

export const handleGetVatReturnBankDetails = function* ({ payload }) {
  try {
    const response = yield call(getVatReturnBankDetails, payload);
    if (response.isAxiosError)
      return yield put(actions.getVatReturnBankDetailsFailure(response.message));
    yield put(actions.getVatReturnBankDetailsSuccess(response));
  } catch (e) {
    yield put(actions.getVatReturnBankDetailsFailure(e));
  }
};

export const handleCzechEconomicActivityListRequest = function* ({ payload }) {
  try {
    const response = yield call(getCzechEconomicActivityList, payload);
    if (response.isAxiosError)
      return yield put(actions.getCzechEconomicActivityListFailure(response.message));
    yield put(actions.getCzechEconomicActivityListSuccess(response));
  } catch (e) {
    yield put(actions.getCzechEconomicActivityListFailure(e));
  }
};

export const handleGetItalyVatReturnEntryListRequest = function* ({ payload }) {
  try {
    const response = yield call(getItalyVatReturnList, payload);
    if (response.isAxiosError)
      return yield put(actions.getItalyVatReturnListFailure(response.message));
    yield put(actions.getItalyVatReturnListSuccess(response));
  } catch (e) {
    yield put(actions.getItalyVatReturnListFailure(e));
  }
};

export default all([
  takeEvery(types.GENERATE_VAT_RETURN_REQUEST, handleGenerateVatReturnRequest),
  takeEvery(types.GET_VAT_RETURN_ENTRY_LIST_REQUEST, handleGetVatReturnEntryListRequest),
  takeEvery(types.DOWNLOAD_VAT_RETURN_REQUEST, handleDownloadVatReturnRequest),
  takeEvery(types.DOWNLOAD_FILED_RETURN_REQUEST, handleDownloadFiledReturnFiles),
  takeEvery(types.SEND_VAT_RETURN_EMAIL_REQUEST, handleSendVatReturnEmailRequest),
  takeEvery(types.GET_VAT_RETURN_BANK_DETAILS_REQUEST, handleGetVatReturnBankDetails),
  takeEvery(types.GET_CZECH_ECONOMIC_ACTIVITY_LIST_REQUEST, handleCzechEconomicActivityListRequest),
  takeEvery(types.GET_ITALY_VAT_RETURN_ENTRY_LIST_REQUEST, handleGetItalyVatReturnEntryListRequest),
  takeEvery(types.DOWNLOAD_SAFT_REQUEST, handleRequest),
  takeEvery(types.DOWNLOAD_OFFICIAL_XML_REQUEST, handleRequest),
]);
